import React from 'react';
import PropTypes from 'prop-types';
import { currencyFormatter } from 'utils/formatter';
import { PAYMENT_METHOD_LABEL_SHIFT } from 'utils/paymentMethodConstants';
import CashRow from '../CashRow';

class ShiftDetailOther extends React.Component {
  render() {
    const { shift } = this.props;
    return (
      <div className="row">
        <div className="col-lg-12">
          <div className="form-group col-sm-12 label-section">
            <label>Other</label>
          </div>
          <div className="col-sm-12 other_detail no-padding-right">
            {shift.total_edc !== 0 && (
              <CashRow
                label={PAYMENT_METHOD_LABEL_SHIFT.EDC}
                value={currencyFormatter(shift.total_edc)}
              />
            )}
            <CashRow
              label={PAYMENT_METHOD_LABEL_SHIFT.GO_PAY}
              value={currencyFormatter(shift.total_go_pay)}
            />
            <CashRow
              label={PAYMENT_METHOD_LABEL_SHIFT.GIFT_CARD}
              value={currencyFormatter(shift.total_gift_card)}
            />
            <CashRow
              label={PAYMENT_METHOD_LABEL_SHIFT.OTHER}
              value={currencyFormatter(shift.total_other)}
            />
            <CashRow
              label={PAYMENT_METHOD_LABEL_SHIFT.OTHER_REFUNDS}
              value={
                Number.isFinite(-shift.other_refunds) &&
                currencyFormatter(-shift.other_refunds)
              }
            />
            <CashRow
              label={PAYMENT_METHOD_LABEL_SHIFT.EXPECTED_OTHER_PAYMENT}
              value={currencyFormatter(shift.expected_other_payment)}
            />
          </div>
        </div>
      </div>
    );
  }
}

ShiftDetailOther.propTypes = {
  shift: PropTypes.object,
};

export default ShiftDetailOther;
